module.exports = __webpack_public_path__ + "img/mile3.88ceb6a3.webp";